module.exports = __webpack_public_path__ + "img/guizhouHints_18.4a301b46.jpg";